import ServiceBase from './serviceBase';
import {
  OperationEsrrList,
  OperationEsrrFilter,
  OperationEsrrQuestions,
  OperationEsrrAnswers,
  OperationEsrrAnswer,
} from './types/Esrr';

class OperEsrrService extends ServiceBase {
  getEsrr = async (filter: OperationEsrrFilter): Promise<OperationEsrrList> => {
    const { operationId, pageNumber, sortDescending, sortField } = filter;
    const queryParams = `pageNumber=${pageNumber}&pageSize=10&sortField=${sortField}&sortDescending=${sortDescending}`;
    return this.get<OperationEsrrList>(`esrr/operation/${operationId}/list?${queryParams}`);
  };

  getEsrrQuestions = async (): Promise<OperationEsrrQuestions[]> =>
    this.get<OperationEsrrQuestions[]>('esrrquestion');

  downloadDocument = async (operationId: number, esrrId: number): Promise<boolean> => {
    await this.download(`esrr/${esrrId}/download`);
    return true;
  };

  saveAnswers = async (payload: OperationEsrrAnswers): Promise<void> =>
    this.post<void>(`esrr/create`, payload);

  getLatestAnswers = async (operationId: number): Promise<OperationEsrrAnswer[]> =>
    this.get<OperationEsrrAnswer[]>(`esrr/operation/${operationId}/answers/latest`);

  getAnswers = async (id: number): Promise<OperationEsrrAnswer[]> =>
    this.get<OperationEsrrAnswer[]>(`esrr/answers/${id}`);

  deleteEsrr = async (esrrId: number): Promise<boolean> => {
    await this.delete(`esrr/${esrrId}`);
    return true;
  };
}

const operEsrrService = new OperEsrrService();

export default operEsrrService;
